<template>

    <PantalladeCarga v-if="cargando == true" titulo="Cargando..."></PantalladeCarga>



    <div class="container" style="padding-top:20px; padding-bottom:20px;">

        <div v-if="title != '' && subtitle != ''" style="padding: 20px; padding-bottom: 0px; text-align: center;">
            <h2 class="h3" v-html="title"></h2>
            <p class="fs-4" v-html="subtitle"></p>
        </div>

        <div v-if="quotation==true && productosMostrados >= 1" style="padding: 20px; padding-right:30px; padding-bottom: 35px; text-align: right;">
            <p class="fs-6" style="padding:0px; margin: 0px; color:#000;"><b>{{$store.state.nombreTomador}}</b></p>
            <p class="fs-6" style="padding:0px; margin: 0px;">Presupuesto Nº {{anio}}/{{idPresupuesto}}/08</p>
            <p class="fs-6" style="padding:0px; margin: 0px;">Nº de Asegurados: <b>{{$store.state.NumeroAsegurados}}</b></p>
            <p class="fs-6" style="padding:0px; margin: 0px;">Forma de Pago: <i>{{periodoCambiar}}</i> <u><strong @click="visualizarFormadePago()" style="cursor:pointer;">[ Cambiar ]</strong></u></p>

        </div>


        <!-- Mensaje No Precio -->

        <div class="row text-center" v-if="quotation==true && productosMostrados == 0" style="padding:10px;">

            <div class="col shadow pl-5 pr-5 custom-bg-soft rounded text-center" style="padding:25px; text-align: center; border: 1px solid #bdbdbd; padding-top:20px;">
                
                <img src="/wp-content/themes/tema-algoritmica/assets/img/blocks/errorPresupuesto.png" width="70">

                <p class="text-black" style="font-size:15pt; margin-top:20px;">Upsss!! <br>En estos momentos, no hemos podido ofrecerle precio. <br>Disculpe las molestias. </p>

            </div>
        </div>


        <!-- Selección Periodo de Comparacion -->

        <div class="row text-center" v-if="verFormadePago == true" style="padding:10px;">

            <div class="col shadow pl-5 pr-5 custom-bg-primary rounded text-center" style="padding:15px; text-align: center; border: 1px solid #bdbdbd;">

                <p class="text-white">Seleccione el Fraccionamiento del Pago</p>

                <select class="form-select form-control text-center" id="TipoPago" aria-label="Seleccione el Fraccionamiento del Pago" v-model="periodoCambiar" style="color: #000; font-weight: bold; font-size:10pt; border: 2px solid #bdbdbd;">
                    <template v-for="(Periodo, Tiempo) in PeriodosEscritos" :index="Tiempo">
                        <option v-if="Tiempo == periodoCambiar" :value="Tiempo" selected>{{Tiempo}}</option>
                        <option v-else :value="Tiempo">{{Tiempo}} </option>
                    </template>
                </select>

            </div>
        </div>
           
        <!-- Selección Periodo de Comparacion -->

            <!-- Selección Tipo de Seguro para Escritorio -->
            <div class="row desktop-only" v-if="(etiquetas.length >= 1 && ready == true)">
                
                <template v-for="(etiqueta, index3) of etiquetas" :key="index3">

                    <div v-if="etiqueta == etiquetaSeleccionada" class="col shadow pl-5 pr-5 rounded nav-link text-center custom-bg-primary text-white" @click="elegirEtiquetaDesktop(etiqueta)">
                        <p class="resumen_etiqueta"><strong>{{etiqueta}}</strong></p>
                        <p class="resumen_precios">Precios desde <b>{{ preciosEtiquetas[index3] }} {{periodoComparativo}}</b></p>
                    </div>

                    <div v-else class="col shadow pl-5 pr-5 bg-white rounded nav-link text-center" style="background-color:#fff;" @click="elegirEtiquetaDesktop(etiqueta)">
                        <p class="resumen_etiqueta"><strong>{{etiqueta}}</strong></p>
                        <p class="resumen_precios">Precios desde <b>{{ preciosEtiquetas[index3] }} {{periodoComparativo}}</b></p>
                    </div>

                </template>

            </div>

            <!-- Selección Tipo de Seguro para Movil A -->
            <div class="row mobile-only custom-bg-soft" v-if="(etiquetas.length >= 1 && ready == true) && opcionMovil == 'a'" style="padding:20px; margin-top:20px;">
                
                <p class="text-black" style="font-weight:bold; font-size: 14pt;">Seleccione el Tipo de Seguro:</p>


                <template v-for="(etiqueta, index3) of etiquetas" :key="index3">

                    <div v-if="etiqueta == etiquetaSeleccionada" style="margin-top:10px;" class="rounded boton-movil-etiqueta text-center custom-bg-primary text-white" @click="elegirEtiqueta(etiqueta)">
                        <p class="resumen_etiqueta"><strong>{{etiqueta}}</strong></p>
                    </div>

                    <div v-else class="bg-white boton-movil-etiqueta rounded text-center" style="margin-top:10px;" @click="elegirEtiqueta(etiqueta)">
                        <p class="resumen_etiqueta"><strong>{{etiqueta}}</strong></p>
                    </div>

                </template>

            </div>
            <!-- Selección Tipo de Seguro para Movil B -->

            <div class="row text-center mobile-only" v-if="(etiquetas.length >= 1 && ready == true) && opcionMovil == 'b'" style="padding:10px;">

                <div class="col shadow pl-5 pr-5 custom-bg-primary rounded text-center" style="padding:15px; text-align: center; border: 1px solid #bdbdbd;">

                    <p class="text-white">Seleccione el Tipo de Seguro</p>

                    <select class="form-select form-control text-center" id="TipoSeguro" aria-label="Seleccione el Tipo de Seguro" v-model="etiquetaSeleccionada" style="font-weight: bold; font-size:10pt; border: 2px solid #bdbdbd;">
                        <template v-for="(etiqueta, index4) in etiquetas" :key="index4">
                            <option v-if="etiquetaSeleccionada == etiqueta" :value="etiqueta" selected>{{etiqueta}}</option>
                            <option v-else :value="etiqueta" selected>{{etiqueta}} </option>
                        </template>
                    </select>

                </div>
            </div>
           
            <!-- Selección Tipo de Seguro para Movil -->


    </div>
    <div class="container" style="margin-top:10px; margin-bottom:30px;">


        <p class="text-black mobile-only" id="lista-productos-parrilla" style="font-size:15pt;">Resultados para :<br><b>{{ etiquetaSeleccionada }}</b></p>


        <p class="text-black desktop-only" style="font-size:18pt;">Resultados para &nbsp; <b>{{ etiquetaSeleccionada }}</b></p>

        <p class="text-black" style="font-size:13pt;"><i>Con forma de pago <b>{{ periodoCambiar }}</b></i></p>


        <template v-if="(productosElegidos.length >= 1 && filas.length >= 1 && ready == true)">

            <div class="rounded mx-lg-auto mb-7">

            <template v-for="(productosFila, index) of filas" :key="index">

                <Fila
                    :products="productosFila"
                    :quotation="quotation"
                    :idPresupuesto="idPresupuesto"
                    :UrlDescargaPresupuesto="UrlDescargaPresupuesto"
                    :productoAnterior="productoAnterior"
                    @clickProducto="clickProducto"
                    :mostrarInfo="mostrarInfo"
                    v-if="index <= maxFilasShow"
                    >
                    
                </Fila>


            </template>


            </div>
        </template>
    </div>

    <div class="container" style="padding-top:20px; padding-bottom:20px;">

        <!-- Selección Tipo de Seguro para Movil A -->
        <div class="row mobile-only custom-bg-soft" v-if="(etiquetas.length >= 1 && ready == true) && opcionMovil == 'a'" style="padding:20px; margin-top:20px;">
            
            <p class="text-black" style="font-weight:bold; font-size: 14pt;">Seleccione el Tipo de Seguro:</p>


            <template v-for="(etiqueta, index3) of etiquetas" :key="index3">

                <div v-if="etiqueta == etiquetaSeleccionada" style="margin-top:10px;" class="rounded boton-movil-etiqueta text-center custom-bg-primary text-white" @click="elegirEtiqueta(etiqueta)">
                    <p class="resumen_etiqueta"><strong>{{etiqueta}}</strong></p>
                </div>

                <div v-else class="bg-white boton-movil-etiqueta rounded text-center" style="margin-top:10px;" @click="elegirEtiqueta(etiqueta)">
                    <p class="resumen_etiqueta"><strong>{{etiqueta}}</strong></p>
                </div>

            </template>

        </div>
    </div>

</template>

<script>


import Fila from './Fila.vue'
import Prices from '../MatrixPrices'
import PantalladeCarga from '../PantalladeCarga.vue'


export default {
  name: 'Comparador',
  components : {Fila, PantalladeCarga},
  props: {
    
    title: String,
    subtitle: String,
    products : Array,
    filter: Array,
    quotation: Boolean,
    UrlDescargaPresupuesto: String,
    productoAnterior: Boolean,
    numeroColumnasMaximo: Number,
    idPresupuesto: String,
    trackingUrlSave: String,
    urlActiveCampaign: String,
    ProductoSeleccionadoEnParrilla: String,
    AddonsSeleccionados: Array,
    PeriodoSeleccionado: String,
    mostrarInfo: Boolean,
    PeriodosEscritos: Object


  },

  data: function () {
              return {
                productosElegidos: [],
                filas: [],
                ready: false,
                maxFilasShow: 10,
                cargando: false,
                anio: 2024,
                etiquetas: [],
                etiquetaSeleccionada: "",
                preciosEtiquetas: [],
                periodoComparativo: "",
                periodoCambiar: "",
                verFormadePago: false,
                productosMostrados : 0,
                opcionMovil: "a" //Poner a para el estilo boton y b para el estilo lista.


              }
  },

  mounted: async function(){


    this.cargando = true;

    await this.filtrarProductos();

    await this.crearEtiquetas(await this.startFromZero(this.productosElegidos));



    if (this.etiquetaSeleccionada == "")
    {


        if (etiquetaPreMarcada == "")
        {

            this.etiquetaSeleccionada = this.etiquetas[0];


        } else {

            // Verificar si etiquetaPreMarcada está en this.etiquetas, si no, usar this.etiquetas[0]
            if (this.etiquetas && this.etiquetas.includes(etiquetaPreMarcada)) {
                this.etiquetaSeleccionada = etiquetaPreMarcada;
            } else {
                this.etiquetaSeleccionada = this.etiquetas[0];
            }



        }


    }


    await this.ordernarProductos();
    await this.establecerColumnas();

    this.ready = true;
    this.cargando = false;

    this.periodoComparativo = this.PeriodosEscritos[this.PeriodoSeleccionado];


    if (this.periodoCambiar == "")
    {

        this.periodoCambiar = this.PeriodoSeleccionado;

    }


    this.$watch('periodoCambiar', async function () {

        await this.resetPeriodoSeleccionado(this.periodoCambiar);

    });





    this.$watch('etiquetaSeleccionada', async function () {


        this.filas = [];

        this.cargando = true;
        this.ready = false;

        await this.filtrarProductos();
        await this.ordernarProductos();
        await this.establecerColumnas();


        this.ready = true;
        this.cargando = false;

    });



    let today = new Date();
    this.anio = today.getFullYear();


  },
  methods: {

    SeleccionarProducto : async function(codigo){

        await this.$store.commit('seleccionarProductoParrilla', codigo);    

    },

    AddonsParrilla : async function(extensiones){

        await this.$store.commit('resetAddonsParrilla', extensiones);

    },

    resetPeriodoSeleccionado : async function(periodo){

        await this.$emit("CambiarPeriodoSeleccionado", periodo);


    },

    construirUrlConParametros : function(urlBase) {
        // Función helper para construir URL con parámetros GET
        let url = urlBase;
        let parametros = [];

        // Añadir idPresupuesto si existe
        if (this.idPresupuesto != null) {
            parametros.push("idPresupuesto=" + this.idPresupuesto);
        }

        // Añadir idAgente si existe la constante
        if (typeof window.idAgente !== 'undefined' && window.idAgente) {
            parametros.push("idAgente=" + window.idAgente);
        } else if (typeof idAgente !== 'undefined' && idAgente) {
            // Fallback: intentar sin window por si está en scope local
            parametros.push("idAgente=" + idAgente);
        }

        // Añadir PeriodoSeleccionado con el valor de this.periodoCambiar
        if (this.periodoCambiar && this.periodoCambiar != "") {
            parametros.push("PeriodoSeleccionado=" + encodeURIComponent(this.periodoCambiar));
        }

        // Construir la URL final
        if (parametros.length > 0) {
            url += "?" + parametros.join("&");
        }

        return url;
    },

    visualizarFormadePago : async function(){

        this.verFormadePago = true;


    },


    clickProducto : async function(producto, price, tipo){


        if (this.quotation == true)
        {


            if (tipo != "none"){

                this.cargando = true;

            } 


            let addons = [];
            await this.SeleccionarProducto(producto);
            await this.AddonsParrilla(addons);
            //await this.resetPeriodoSeleccionado("Mensual");
            
            await this.$store.commit('ActualizarPrecioFinal', price);

            
            if (this.trackingUrlSave != "")
            {

                let tracking = await Prices.SaveTracking(this.trackingUrlSave, this.idPresupuesto, this.$store.state.PrecioFinal, this.PeriodoSeleccionado, this.AddonsSeleccionados, this.ProductoSeleccionadoEnParrilla);


            }

            if (this.urlActiveCampaign != "")
            {

                let trackingActive = await Prices.SaveTracking(this.urlActiveCampaign, this.idPresupuesto, this.$store.state.PrecioFinal, this.PeriodoSeleccionado, this.AddonsSeleccionados, this.ProductoSeleccionadoEnParrilla);


            }


            if (tipo != "none"){

                this.cargando = false;

            } 

        } 



        if (await this.datosProducto(producto))
        {

            let datos = await this.datosProducto(producto);


            if (tipo == "contratar")
            {
            

                let url = this.construirUrlConParametros(datos["url"]);
                window.location.href = url;



            }

            if (tipo == "info")
            {

                let url = this.construirUrlConParametros(datos["link"]);
                window.location.href = url;



            }


            if (tipo == "download")
            {

                console.log("Descargando Presupuesto...");


            }


            if (tipo == "none")
            {

                console.log("Guardando Preferencias...");


            }
        }





    },

    masProductos : async function(){


       this.maxFilasShow = (this.maxFilasShow+1);



    },


    elegirEtiqueta : async function(etiqueta){


       this.etiquetaSeleccionada = etiqueta;

       var elementoParrilla = document.getElementById("lista-productos-parrilla");

       var scrollDiv = elementoParrilla.getBoundingClientRect().top + window.scrollY;
    
       console.log(scrollDiv);

       window.scroll({
            top: scrollDiv-50,
            behavior: 'smooth'
        });

       //document.getElementById("lista-productos-parrilla").scrollIntoView();

    },



    elegirEtiquetaDesktop : async function(etiqueta){


       this.etiquetaSeleccionada = etiqueta;

    },



    range : function(start, end){

        if(start === end) return [start];
            return [start, ...this.range(start + 1, end)];

    },


    filtrarProductos: async function(){

        this.productosElegidos = [];

        if (this.filter != null || this.filter.length >= 1)
        {
        
            for (let producto of this.products)
            {


                if (this.filter.includes(producto.name))
                {


                    this.productosElegidos.push(producto);


                }


            }

        } else {


            this.productosElegidos = productos;
            

        }   




    },

    ordernarProductos: async function(){

        var ProductosOrdenados = [];

        var ProductosFinales = [];


        for (let producto of this.productosElegidos)
        {

            if (this.filter.indexOf(producto.name) >= 0){


                if (producto.show == true)
                {

                    this.productosMostrados = (this.productosMostrados+1);

                }

                if (producto.tags.includes(this.etiquetaSeleccionada))
                {

                    let orden = this.filter.indexOf(producto.name);
                    ProductosOrdenados[orden] = producto;

                }



            }


        }

        var ProductosFinales = ProductosOrdenados.sort((a, b) => a.price - b.price);

        this.productosElegidos = await this.startFromZero(ProductosFinales);




    },


    saberPreciomasBajo: async function(Productos, Etiqueta){

        var ProductosOrdenados = [];

        for (let producto of Productos)
        {

            if (this.filter.indexOf(producto.name) >= 0){

                if (producto.tags.includes(Etiqueta))
                {

                    ProductosOrdenados.push(producto);

                }

            }

        }

        var ProductosFinales = ProductosOrdenados.sort((a, b) => a.price - b.price);


    
        let PrecioMasBajo = ProductosFinales[0]["price"];



        return PrecioMasBajo;



    },



    crearEtiquetas: async function(productos){


        function uniqueFilter(value, index, self) {
            return self.indexOf(value) === index;
        }

        var etiquetas = [];

        for (let producto of productos)
        {


            for (let tag of producto.tags)
            {


                etiquetas.push(tag);

            }


        }

        let nuevas = etiquetas.filter(uniqueFilter);

        this.etiquetas = nuevas;

        for (let etiqueta of nuevas){


            let precio = await this.saberPreciomasBajo(productos, etiqueta);

            let precioEtiqueta = (Math.round((precio + Number.EPSILON) * 100) / 100);

            this.preciosEtiquetas.push(precioEtiqueta);


        }


    },

    datosProducto: async function(codigo){



        for (let producto of this.productosElegidos)
        {


            if (producto.cod == codigo)
            {

                return producto;

            }

        }



    },

    startFromZero: async function(arr){

        var newArr = [];
        var count = 0;

        for (var i in arr) {
            newArr[count++] = arr[i];
        }

        return newArr;

    },

    establecerColumnas: async function(){


        let numeroProductos = this.productosElegidos.length;


        if (numeroProductos >= this.numeroColumnasMaximo)
        {


            let numeroFilas = Math.round(numeroProductos/this.numeroColumnasMaximo);

            let rangofilas = this.range(1, numeroFilas);
            let rangocolumnas = this.range(1, this.numeroColumnasMaximo);


            var indice = 0;


            for (let fila in rangofilas)
            {   

                var filaMatrix = [];


                for (let columna in rangocolumnas)
                {   

                    if (this.productosElegidos[indice])
                    {

                        filaMatrix.push(this.productosElegidos[indice]);
                    
                        indice = (indice+1);

                    }


                }


                this.filas.push(filaMatrix);



            }



        } else {



            this.filas.push(this.productosElegidos);


        }






    }


  }

}
</script>


<style scoped>

  .resumen_precios {

    font-size:12pt;
    margin-top:5px;

  }

  .resumen_etiqueta {

    font-size:12pt;

  }


  .nav-link {

    cursor: pointer;
    margin-left:10px; 
    margin-right:10px;
    border:1px solid #bdbdbd;
    padding-top:20px;

  }


  .active {

    cursor: none;

  }

  .boton-movil-etiqueta {

    cursor: pointer;
    padding-top:20px;
    padding-bottom:20px;
    text-align: center;
    border: 1px solid #bdbdbd;
  }

  @media only screen and (max-width: 768px) {
    
        .desktop-only {

            display:none;

        }

        .mobile-only {

            display:block;

        }


    }

    @media only screen and (min-width: 768px) {


        .desktop-only {

            display:flex;

        }

        .mobile-only {

            display:none;

        }


    }


</style>

